import { render, staticRenderFns } from "./FbSubmit.vue?vue&type=template&id=a6986a8a&scoped=true"
import script from "./FbSubmit.vue?vue&type=script&lang=js"
export * from "./FbSubmit.vue?vue&type=script&lang=js"
import style0 from "./FbSubmit.vue?vue&type=style&index=0&id=a6986a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6986a8a",
  null
  
)

export default component.exports